import React from "react";
import { Avatar, Grid, Typography } from "@sumprio/ui";
import type { FeedItem } from "./types";
import { getInitials } from "./utils";

export interface ActivityFeedItemProps extends FeedItem {
  avatarSize?: "sm" | "md";
}

export function ActivityFeedItem({
  name,
  initials: initialsProp,
  message,
  timestamp,
}: ActivityFeedItemProps) {
  const initials = initialsProp ?? getInitials(name, "??");

  return (
    <Grid display="flex" flexDirection="row" gap="md" width="100%">
      <Grid display="flex" flexDirection="column" alignItems="center" style={{ flexShrink: 0 }}>
        <Avatar type="initial" size="sm" initials={initials} />
      </Grid>
      <Grid
        display="flex"
        flexDirection="column"
        gap="xs"
        style={{ minWidth: 0, flex: 1, paddingBottom: 4 }}
      >
        <Grid display="flex" flexDirection="row" flexWrap="nowrap" gap="xs" alignItems="baseline">
          <Typography variant="body" bodySize="sm" bodyWeight="medium" style={{ flexShrink: 0 }}>
            {name}
          </Typography>
          <Typography
            variant="body"
            bodySize="sm"
            bodyWeight="regular"
            color="secondary"
            style={{ minWidth: 0 }}
          >
            {message}
          </Typography>
        </Grid>
        <Typography variant="body" bodySize="xs" bodyWeight="regular" color="secondary">
          {timestamp}
        </Typography>
      </Grid>
    </Grid>
  );
}
